module.exports = __webpack_public_path__ + "img/kualitas-terbaik.4575849f.svg";